import Card from "components/card/Card";
import Page from "components/page/Page";
import React from "react";
import { SkeletonBar } from "components/skeleton";
import { useTranslation } from "react-i18next";


export default function PurchaseOrderPageSkeleton(props: { creditMemo?: boolean }) {
    const { t } = useTranslation();

    return (
        <>
            <Page.Section twoThirds>
                <Card title={t("Items")}>
                    <Card.Section>
                        <div className="flex justify-between items-center">
                            <SkeletonBar width="11rem" height="1rem" />

                            <div className="flex items-center gap-4">
                                <SkeletonBar width="8rem" height="2rem" />
                                <SkeletonBar width="8rem" height="2rem" />
                            </div>
                        </div>
                    </Card.Section>
                </Card>
            </Page.Section>
            <Page.Section oneThird>
                <Card title={t("Vendor")}>
                    <Card.Section>
                        <div className="flex flex-col gap-2">
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                        </div>
                    </Card.Section>
                </Card>
                {props?.creditMemo ? (
                    <Card title={t("Facility")}>
                        <Card.Section>
                            <div className="flex flex-col gap-2">
                                <SkeletonBar width="11rem" height="1rem" />
                                <SkeletonBar width="11rem" height="1rem" />
                            </div>
                        </Card.Section>
                    </Card>
                ) : (
                    <>
                        <Card title={t("Ship To")}>
                            <Card.Section>
                                <div className="flex flex-col gap-2">
                                    <SkeletonBar width="11rem" height="1rem" />
                                    <SkeletonBar width="11rem" height="1rem" />
                                </div>
                            </Card.Section>
                        </Card>
                        <Card title={t("Bill To")}>
                            <Card.Section>
                                <div className="flex flex-col gap-2">
                                    <SkeletonBar width="11rem" height="1rem" />
                                    <SkeletonBar width="11rem" height="1rem" />
                                </div>
                            </Card.Section>
                        </Card>
                    </>
                )}

                <Card title={t("Notes")}>
                    <Card.Section>
                        <div className="flex flex-col gap-2">
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                            <SkeletonBar width="11rem" height="1rem" />
                        </div>
                    </Card.Section>
                </Card>
            </Page.Section>
        </>
    );
}